export enum StatusesColors {
  InProgress = '#77AFE1',
  Finished = '#37B348',
  BehindSchedule = '#FFB300',
  OverBudget = '#DC1515'
}
